export { povileThemeColors } from './povile';
export { directaThemeColors } from './directa';
export { limePayThemeColors } from './limePay';
export { oneKeyThemeColors } from './oneKey';
export { tupayTheme } from './tupay';
export { gatewayDepositThemeColors } from './gateway_deposit';
